import React from "react";
import "./styles.scss";

export default function TableError({ failedImports }) {
  return (
    failedImports.length !== 0 && (
      <div className="table-error-message">
        <table>
          <thead>
            <tr>
              <th>CPF</th>
              <th>Motivo do Erro</th>
            </tr>
          </thead>
          <tbody>
            {failedImports.map(({ cpf, reason }, index) => (
              <tr key={`${index} - ${cpf} ${reason}`}>
                <td>{cpf}</td>
                <td>{reason}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th />
              <th />
            </tr>
          </tfoot>
        </table>
      </div>
    )
  );
}
